import React, { Component } from "react";
import {
  Collapsible,
  CollapsibleItem,
  Collection,
  CollectionItem,
  Icon,
} from "react-materialize";

import CourseConstants from "../Constants";
import { check, play } from "../../../assets";
import UserConstants from "../../User/Constants";
import { trans } from "../../Lang";
import ReactTooltip from "simple-react-tooltip";

class CourseModuleList extends Component {
  getResourceIcon = (topic) => {
    let icon = "";
    let { completed, selected, resource_type } = topic;

    /*if (selected) {
			return <img src={'/img/white-label/icons/ic_modul_solid.svg'} className="custom-resource-icon" />
		} else*/ /*if (completed) {
			return <img src={check} id="custom-resource-icon" />
		} else*/
    if (resource_type === CourseConstants.TYPE_VIDEO) {
      return <Icon small>play_circle_outline</Icon>;
    } else if (resource_type === CourseConstants.TYPE_AUDIO) {
      return <Icon small>library_music</Icon>;
    } else if (resource_type === CourseConstants.TYPE_PDF) {
      return <Icon small>picture_as_pdf</Icon>;
      // return (
      //   <img
      //     src={"/img/white-label/icons/ic_modul_solid.svg"}
      //     // className="custom-resource-icon"
      //   />
      // );
      //return <Icon small>picture_as_pdf</Icon>
    } else if (resource_type === CourseConstants.TYPE_QUIZ) {
      return <Icon small>list</Icon>;
    }

    return <Icon small>{icon}</Icon>;
  };

  render() {
    const { data, activeTopic, handleClickTopic } = this.props;

    return (
      <Collapsible className="modules-collapsible modules-detail">
        {data.modules.map((module, moduleIndex) => (
          <CollapsibleItem
            key={moduleIndex}
            header={module.title}
            expanded={moduleIndex == 0}
            icon="keyboard_arrow_up"
          >
            <Collection>
              {module.topics.map((topic, topicIndex) => (
                <CollectionItem
                  className={activeTopic.uuid === topic.uuid ? "active" : ""}
                  data-modulekey={moduleIndex}
                  data-topickey={topicIndex}
                  data-locked={topic.locked}
                  onClick={handleClickTopic.bind(
                    this,
                    moduleIndex,
                    topicIndex,
                    topic.locked
                  )}
                  href={"#" + topic.uuid}
                  key={topicIndex}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flexShrink: 0, width: "36px" }}>
                      {topic.locked ? (
                        <Icon>lock_outline</Icon>
                      ) : (
                        this.getResourceIcon(topic)
                      )}
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      {" "}
                      <div className="font-light">
                        {topic.title.length > 25 ? (
                          <span>
                            <span data-tip={topic.title}>
                              {topic.title.substr(0, 25) + " ... "}
                            </span>
                            <ReactTooltip place="bottom" />
                          </span>
                        ) : (
                          topic.title
                        )}
                      </div>
                      <div>
                        <div className="topic-length">
                          {topic.resource_length &&
                          topic.resource_type != CourseConstants.TYPE_QUIZ ? (
                            <span>
                              {trans.duration} : {topic.resource_length}{" "}
                              {trans.minute}
                            </span>
                          ) : (
                            <span>{topic.resource_length}</span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="icon-right">
                      {topic.completed ? <Icon>check_circle</Icon> : null}
                    </div>
                  </div>
                </CollectionItem>
              ))}
            </Collection>
          </CollapsibleItem>
        ))}
      </Collapsible>
    );
  }
}

export default CourseModuleList;



// WEBPACK FOOTER //
// ./src/components/Course/components/CourseModuleList.js